#import "../../../../../core-entity/widgets/email-sequences-widget/graphql/fragments/email-sequence-fragment-sparse.graphql"
#import "../../../../../core-entity/widgets/email-sequences-widget/graphql/fragments/queued-email-fragment-sparse.graphql"

query GetLeadManuallyStartedEmailSequences($leadId: ID!) {
    lead(id: $leadId) {
        id
        queuedEmails {
            id
            emailSequence {
                ...EmailSequenceFragmentSparse
            }
            ...QueuedEmailFragmentSparse
        }
    }
}
